"use client";

import { useEffect } from "react";
import { TrackJS } from "trackjs-nextjs";

interface ErrorBoundaryTrackerProps {
  pageName?: string;
  children: React.ReactNode;
}

export default function ErrorBoundaryTracker({ pageName = "404", children }: ErrorBoundaryTrackerProps) {
  useEffect(() => {
    // Log that user reached an error page
    if (typeof window !== "undefined") {
      console.info(`User reached ${pageName} page`);
      try {
        TrackJS.track(new Error(`${pageName} page viewed`));
      } catch (e) {
        console.warn("TrackJS not available for error page tracking");
      }
    }
  }, [pageName]);

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      try {
        TrackJS.track(new Error(`${pageName} Page Error: ${event.message}`));
      } catch (e) {
        console.error(`Error on ${pageName} page:`, event.message);
      }
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, [pageName]);

  return <>{children}</>;
}
